import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import qs from 'qs'
import axios from 'axios';
import {buscarUsuarios} from '../../../actions/usuario/buscarUsuarios';
import excluirUsuario from '../../../actions/usuario/exclurUsuario';
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil';
import { URL } from '../../../util/ambienteActions';

export class PainelGerenciarUsuario extends React.Component {
  // eslint-disable-next-line no-unused-vars
  constructor (props) {
    super(props);
    this.state = {
      validado: false
    };
  }

  componentDidMount () {
    const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
    if (parametros.email != null && parametros.codigo != null) {
      const url = `${URL}/cliente/public/validar`;
      const data = {
        email: parametros.email,
        codigo: parametros.codigo
      }
      axios.post(url, data, SLOW_REQUEST_CONFIG).then((response) => {
        if (response != null) {
          this.setState({ validado: response.data })
        }
      })
    }
  }

  render () {
    if (this.state.validado) {
      return 'Cadastro Validado com sucesso'
    }
    return ''
  }
}


export const mapStateToProps = state => (
  {
    usuarios: state.usuarios,
    empresaSelecionada: state.empresaSelecionada,
    changeFieldValue,
  });


export default connect(mapStateToProps, { buscarUsuarios, excluirUsuario })(reduxForm({
  form: 'formularioCadastroUsuario'
})(PainelGerenciarUsuario))
